import { createLucideIcon } from 'lucide-react';
export const CaretDownFilled = createLucideIcon('caret-down-filled', [
  [
    'path',
    {
      d: 'M21 9H3L12 18L21 9Z',
      key: '1sgah7',
    },
  ],
]);
